<template>
  <div>
    <component
      :is="component"
    />
  </div>
</template>
<script>
import Func1Inbox from '@/views/1/Func1Inbox.vue'

export default {
  name: 'Func1',
  data () {
    return {
      component: Func1Inbox
    }
  }
}
</script>
